import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LoginScreen from "./pages/LoginScreen/LoginScreen";
import AdminPanel from "./pages/AdminPanel/AdminPanel";
import ForgotPassword from "./pages/ForgotPassword/ForgotPassword";

// Page imports
import HomeScreen from "./pages/HomeScreen/HomeScreen";
import SignUpScreen from "./pages/SignUpScreen/SignUpScreen";
import AboutPage from "./pages/AboutPage/AboutPage";
import ContactPage from "./pages/ContactPage/ContactPage";
import YachtsScreen from "./pages/YachtsScreen/YachtsScreen";
import YachtInfoScreen from "./pages/YachtInfoScreen/YachtInfoScreen";
import YachtManagement from "./pages/AdminPanel/YachtManagement";
import ViewYachtDetails from "./pages/AdminPanel/ViewYachtDetails";
import ReservationManagement from "./pages/AdminPanel/ReservationManagement";
import CustomerManagement from "./pages/AdminPanel/CustomerManagement";
import ReservedYachts from "./pages/AdminPanel/ReservedYachts";
import ReservationPage from "./pages/ReservationPage/ReservationPage";
import TermsPage from "./pages/TermsPage/TermsPage";
import NotFoundPage from "./pages/NotFoundPage/NotFoundPage";
import AccountSettings from "./pages/AccountSettings/AccountSettings";

function App() {
    useEffect(() => {
        const checkTokenValidity = () => {
            const token = localStorage.getItem('authToken');

            if (token) {
                try {
                    // JWT token'ı decode et (payload kısmını al)
                    const payload = JSON.parse(atob(token.split('.')[1]));
                    const currentTime = Date.now() / 1000; // Unix timestamp

                    // Token süresi dolmuş mu kontrol et
                    if (payload.exp && payload.exp < currentTime) {
                        console.log('Token süresi dolmuş, localStorage temizleniyor');
                        // Süresi dolmuş - localStorage'ı temizle
                        localStorage.removeItem('authToken');
                        localStorage.removeItem('user');

                        // Navbar'ın güncellenmesi için event tetikle
                        window.dispatchEvent(new Event('loginStatusChanged'));
                    } else {
                        console.log('Token geçerli');
                    }
                } catch (error) {
                    console.log('Token decode hatası, localStorage temizleniyor:', error);
                    // Token bozuk veya decode edilemiyor - temizle
                    localStorage.removeItem('authToken');
                    localStorage.removeItem('user');

                    // Navbar'ın güncellenmesi için event tetikle
                    window.dispatchEvent(new Event('loginStatusChanged'));
                }
            } else {
                console.log('Token bulunamadı');
            }
        };

        // Uygulama mount olduğunda token kontrolü yap
        checkTokenValidity();
    }, []);

    return (
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<HomeScreen />} />
                <Route path="/login" element={<LoginScreen />} />
                <Route path="/register" element={<SignUpScreen />} />
                <Route path="/forgot-password" element={<ForgotPassword />} />
                <Route path="/about" element={<AboutPage />} />
                <Route path="/contact" element={<ContactPage />} />
                <Route path="/yachts" element={<YachtsScreen />} />
                <Route path="/yachts/:id" element={<YachtInfoScreen />} />
                <Route path="/reservation/:id" element={<ReservationPage />} />
                <Route path="/terms" element={<TermsPage />} />
                <Route path="/admin" element={<AdminPanel />} />
                <Route path="/admin/yachts" element={<YachtManagement />} />
                <Route
                    path="/admin/yacht-details/:id"
                    element={<ViewYachtDetails />}
                />
                <Route
                    path="/admin/customers"
                    element={<CustomerManagement />}
                />
                <Route
                    path="/admin/reservations"
                    element={<ReservationManagement />}
                />
                <Route
                    path="/admin/reserved-yachts"
                    element={<ReservedYachts />}
                />
                <Route path="/account-settings" element={<AccountSettings />} />
                <Route path="*" element={<NotFoundPage />} />
            </Routes>
        </BrowserRouter>
    );
}

export default App;
